// ----------------------------------------------------------------------
// THE iOS SWITCH (DESIGN.md §18): every MUI `Switch` in the portal, after the
// `IOSSwitch` of MUI's customised-switch demo. The control is the demo's
// 42 × 26 inside MUI's own 58 × 38 box, so no label or row that holds a
// switch moves; the small one is 34 × 20 with 6px either side (46 × 24).

const IOS_SWITCH = {
  light: { track: '#E9E9EA', on: '#65C466', disabledTrack: 0.7 },
  dark: { track: '#39393D', on: '#2ECA45', disabledTrack: 0.3 },
  focus: '#33CF4D'
};

// the thumb's gap to the edge of its track
const INSET = 2;

const SIZES = {
  medium: { width: 42, height: 26, thumb: 22, padX: 8, padY: 6 },
  small: { width: 34, height: 20, thumb: 16, padX: 6, padY: 2 }
};

// Set from the root, as MUI sets its own small size, so it outranks MUI's.
const geometry = ({ width, height, thumb, padX, padY }) => ({
  width: width + padX * 2,
  height: height + padY * 2,
  padding: `${padY}px ${padX}px`,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: `${padY + INSET}px ${padX + INSET}px`,
    '&.Mui-checked': { transform: `translateX(${width - thumb - INSET * 2}px)` }
  },
  '& .MuiSwitch-thumb': { width: thumb, height: thumb },
  '& .MuiSwitch-track': { borderRadius: height / 2 }
});

export default function Switch(theme) {
  const isLight = theme.palette.mode === 'light';
  const tone = IOS_SWITCH[isLight ? 'light' : 'dark'];

  return {
    MuiSwitch: {
      defaultProps: {
        disableRipple: true
      },
      styleOverrides: {
        root: geometry(SIZES.medium),
        sizeSmall: geometry(SIZES.small),
        switchBase: {
          color: '#FFFFFF',
          transitionDuration: '300ms',
          '&.Mui-checked': {
            color: '#FFFFFF',
            '& + .MuiSwitch-track': {
              backgroundColor: tone.on,
              opacity: 1,
              border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 }
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: IOS_SWITCH.focus,
            border: '6px solid #FFFFFF'
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[isLight ? 100 : 600]
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: tone.disabledTrack
          }
        },
        thumb: {
          boxSizing: 'border-box',
          boxShadow: theme.customShadows.z1
        },
        track: {
          opacity: 1,
          backgroundColor: tone.track,
          transition: theme.transitions.create(['background-color'], {
            duration: 500
          })
        }
      }
    }
  };
}
